import tw from 'tailwind-styled-components';

export const CarouselInner = tw.div<{ $bannerSizeFlag?: string }>`
${(props) =>
  props.$bannerSizeFlag === 'Tall'
    ? 'h-heroCarouselInnerTallMob md:h-heroCarouselInnerTallBannerHeight'
    : 'h-bannerShort md:h-heroInnerbanner'}
relative
`;
